import * as Immutable from 'immutable';

export interface IViewerStore {
	width: number
	height: number
	isFullWidth: boolean
}

const defaultStore = Immutable.Record<IViewerStore>({
	width: typeof window === 'object' ? window.innerWidth : null,
	height: typeof window === 'object' ? window.innerHeight : null,
	isFullWidth: false
});

export default class ViewerStore extends defaultStore implements IViewerStore {}